export default __webpack_public_path__ + "static/media/bracelets.13b86d42.webp";